import {CLEAR_TOTAL_REPORT, FETCH_TOTAL_REPORT, LIST_TOTAL_REPORT, LOADING_TOTAL_REPORT} from "./types";

const init = {
    isLoading: false,
    data: [],
    filter: {}
};
export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_TOTAL_REPORT:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_TOTAL_REPORT:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
            };
        case CLEAR_TOTAL_REPORT:
            return {
                isLoading: false,
                data: []
            };
        case LOADING_TOTAL_REPORT:
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state

    }
}
